'use client';

// Utils
import { combineClasses } from '@shared/utils';

// Constants
import { PROJECT_NAV_ITEMS } from '@/constants';
import { UserRole } from '@shared/constants';

// Components
import { Typography } from '@shared/ui';

// Providers
import { useProject } from '@/providers';
import ProjectArchivedOverlay from '@/components/ProjectArchivedOverlay';
import { NavigationItem, NavigationVariant } from '@/components/NavigationItem';
interface ProjectNavigationProps {
  className?: string;
  userRole?: string;
}
export const ProjectNavigation = ({
  className,
  userRole
}: ProjectNavigationProps) => {
  const {
    project
  } = useProject();
  const isProjectArchived = project?.projectInfo?.archived;
  const isUser = userRole === UserRole.USER;
  if (isProjectArchived && isUser) return null;
  return <nav id="project-navigation" data-testid="navbar" className={combineClasses('bg-project-nav', className)} data-sentry-component="ProjectNavigation" data-sentry-source-file="index.tsx">
      <ProjectArchivedOverlay data-sentry-element="ProjectArchivedOverlay" data-sentry-source-file="index.tsx" />

      <div className={combineClasses('max-w-prj-oversight flex-center mx-auto w-full justify-between relative', 'py-2 sm:py-3.5 px-4 sm:px-6 xl:px-0')}>
        <Typography weight="light" className="text-lg lg:text-2xl text-white" data-sentry-element="Typography" data-sentry-source-file="index.tsx">
          Project Insight
        </Typography>
        <div className="gap-3 xs:gap-8 sm:gap-5.5 flex items-center">
          {PROJECT_NAV_ITEMS.map(({
          href,
          icon
        }) => <NavigationItem key={href} icon={icon} href={href} variant={NavigationVariant.Project} />)}
        </div>
      </div>
    </nav>;
};